module.exports = __webpack_public_path__ + "img/mail.6f8749fc.svg";